import ImageBadges from "./ImageBadges";
export default ImageBadges;
